import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, shareReplay } from 'rxjs';
import { Cluster } from '../models/cluster';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClusterService {
  API_URL = `${environment.apiUrl}/clusters`;
  CACHE_SIZE = 1;
  private cache$!: Observable<Array<Cluster>>;
  isClusterLoading$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}
  get clusters() {
    if (!this.cache$) {
      this.cache$ = this.requestClusters().pipe(shareReplay(this.CACHE_SIZE));
      this.isClusterLoading$.next(true);
    }
    this.isClusterLoading$.next(false);
    return this.cache$;
  }

  private requestClusters() {
    return this.http.get<Cluster[]>(this.API_URL);
  }

  getClusters(): Observable<Cluster[]> {
    return this.http.get<Cluster[]>(this.API_URL).pipe(
      map(clusters => clusters.sort((a, b) => {
          const dateA = a.modifiedDate ? new Date(a.modifiedDate).getTime() : 0;
          const dateB = b.modifiedDate ? new Date(b.modifiedDate).getTime() : 0;
          if (dateB !== dateA) {
            return dateB - dateA;
          }
          return (b.id ?? 0) - (a.id ?? 0);
        }))
      );
  }

  addCluster(cluster: Cluster): Observable<Cluster> {
    return this.http.post<Cluster>(this.API_URL, cluster);
  }

  updateCluster(cluster: Cluster): Observable<Cluster> {
    return this.http.put<Cluster>(`${this.API_URL}/${cluster.id}`, cluster);
  }

  deleteCluster(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }
}
